import React from 'react';
import './App.css';

function App() {
    return (
        <div className="Insight">
            <header className="header">
                <h1>ICA Insight</h1>
                <p className="subtitle">Complete guide to using ICA Insight</p>
            </header>

            <main className="main-content">
                <div className="container">
                    <section className="section">
                        <h2>Getting Started</h2>
                        <p>
                            Welcome to ICA Insight! This manual will guide you through all the features and functionality
                            of ICA Insight.
                        </p>
                    </section>

                    <section className="section">
                        <h2>Access & logging in</h2>
                        <p>
                            Access to Insight is handled exclusively through ICA's own AD.
                        </p>
                    </section>

                    <section className="section">
                        <h2>Main Features</h2>

                        <h3>Navigation</h3>
                        <p>
                            On the left you find the sidebar menu. It provides access to all the features of Insight:
                        </p>

                        <ul>
                            <li><strong>Dashboard</strong> Overview of visits with warnings. A notification badge shows the current number of visits with a warning</li>
                            <li><strong>Inbound Orders</strong> Overview of purchase orders covering orders from the last 30 days and future planned orders</li>
                            <li><strong>Outbound Orders</strong> Overview of shipment orders covering orders from the last 30 days and future planned orders</li>
                            <li><strong>Empty Orders</strong> Overview of tomgods orders covering orders from the last 30 days and future planned orders</li>
                            <li><strong>Visits</strong> Overview of visits covering visits from the last 30 days and future planned visits</li>
                            <li><strong>Dock Overview</strong> Overview of dock doors and their statuses</li>
                            <li><strong>Waiting Area</strong> Overview of all visits currently in the waiting area</li>
                            <li><strong>Virtual Waiting Area</strong> Overview of all visits currently in the virtual waiting area</li>
                            <li>
                                <strong>Administration</strong>
                                <ul>
                                    <li><strong>Vehicles</strong> Manage registered vehicles</li>
                                    <li><strong>Whitelist</strong> Manage whitelisted vehicles</li>
                                    <li><strong>Configuration</strong> Adjust system settings</li>
                                    <li><strong>Dock Doors</strong> Manage dock door information</li>
                                    <li><strong>Commodities</strong> Manage commodity types</li>
                                    <li><strong>Messages</strong> Configur message templates</li>
                                </ul>
                            </li>

                        </ul>
                    </section>

                    <section className="section">
                        <h2>Dashboard</h2>
                        <p>
                            For administrators and users the dashboard provides an overview of all visits that have triggered a warning. These warnings typically occur when a visit has left the facility when it should not have,
                            or when more than 15 mins has passed since the visit was summoned and it still has not arrived at the assigned dock door.<br />
                            From here you can delete or complete a visit, or mark it as processed preventing it from showing up in the dashboard. You can also communicate with the driver by sending an SMS.
                        </p>
                    </section>

                    <section className="section">
                        <h2>Inbound, Outbound, and Empty Orders</h2>
                        <p>
                            Everyone with access to ICA Insight can access the respective overviews of each order type. Here you can see all the details of each order such IDs, logistic unit, commodity, delivery area, assigned dock door, and more.<br />
                            As a reader with limited access you have the option of changing assigned dock doors on a given order, by double-clicking an order an edit window appear allowing you to change the dock door assignment.<br />
                            As admin or user you have full access to each order overview. This allows you to edit more information than just the assigned dock door, e.g. status and scheduled time, as well as creating new orders and uploading/downloading CSV-files of orders.
                        </p>
                    </section>

                    <section className="section">
                        <h2>Visits</h2>
                        <p>
                            Everyone with access to ICA Insight can access the overview of visits. Here you can see all visits and their information, including all orders associated with each visit.<br />
                            As a reader with limited access you have the option of changing assigned dock doors on a given order, by double-clicking an order an edit window appear allowing you to change the dock door assignment.<br />
                            As admin or user you have full access to the visit overview. This allows you to delete, complete, or terminate any visit. You can also terminate orders from here or remove them from the visit they are attached to.
                            Finally communication with the driver can be done by sending an SMS.
                        </p>
                    </section>

                    <section className="section">
                        <h2>Dock Overview</h2>
                        <p>
                            As admin or user you can access the overview of dock doors. Here you can see all dock doors and their current status
                        </p>
                    </section>

                    <section className="section">
                        <h2>Waiting Area</h2>
                        <p>
                            Everyone with access to ICA Insight can access the overview of the waiting area. Here you can see all visits currently in the waiting area.
                        </p>
                    </section>

                    <section className="section">
                        <h2>Virtual Waiting Area</h2>
                        <p>
                            Everyone with access to ICA Insight can access the overview of the virtual waiting area. Here you can see all visits currently in the virtual waiting area.
                        </p>
                    </section>


                    <section className="section">
                        <h1>Administration</h1>

                        <section className="section">
                            <h2>Vehicles</h2>
                            <p>
                                An overview of all registered vehicles. Here you can add, edit, and delete vehicles. If a vehicle is whitelisted you can add rules for timeslots where the whitelist applies.
                            </p>
                        </section>

                        <section className="section">
                            <h2>Whitelist</h2>
                            <p>
                                An overview of all whitelisted vehicles. Here you can add, edit, and delete vehicles. If a vehicle is whitelisted you can add rules for timeslots where the whitelist applies.
                            </p>
                        </section>

                        <section className="section">
                            <h2>Configuration</h2>
                            <p>
                                An overview of all system configurations.<br />
                                The system uses timeslot rules to decide whether a vehicle should be sent to the waiting area, allowed to go directly to a dock door, or rejected for being too early or too late.<br />
                                Each order type, inbound, outbound, and tomgods, have their timeslot configurations. In total there are six timeslot configurations per order type and each is prefixed with the order type it covers, these timeslots are in minutes.
                            </p>

                            <h3>ArrivalOnTimeBefore</h3>
                            <p>
                                ArrivalOnTimeBefore defines how long before the scheduled time a vehicle can arrive
                                and still be considered "on time" for the waiting area.
                                If you increase this value, vehicles are allowed to arrive earlier and still be accepted as
                                on time. This gives drivers more flexibility and reduces the risk of being treated as "too
                                early" and sent away. If you decrease this value, you tighten the rules: vehicles arriving
                                too far ahead of time will no longer be treated as on time and may be rejected or asked
                                to come back closer to their slot.
                            </p>

                            <h3>ArrivalOnTimeAfter</h3>
                            <p>
                                ArrivalOnTimeAfter defines how long after the scheduled time a vehicle can arrive and
                                still be considered "on time" for the waiting area.
                                If you increase this value, vehicles are allowed to arrive later and still be accepted as on
                                time. This makes the operation more forgiving towards delays, such as traffic or loading
                                issues at the previous location. If you decrease this value, you make the planning
                                stricter: vehicles that arrive too long after their scheduled time will no longer be treated
                                as on time and may be rejected or sent away.
                            </p>

                            <h3>RejectBefore</h3>
                            <p>
                                RejectBefore defines how far before the scheduled time a vehicle can arrive and still be
                                within the allowed window. Arrivals earlier than this limit are treated as "too early" and
                                may be rejected or not allowed to enter the area.
                                If you increase this value, you extend the allowed window further back in time, which
                                means fewer vehicles will be classified as "too early." If you decrease this value, very
                                early arrivals are more likely to be rejected and asked to return closer to the planned time.
                            </p>

                            <h3>RejectAfter</h3>
                            <p>
                                RejectAfter defines how long after the scheduled time a vehicle can arrive and still be
                                within the allowed window. Arrivals later than this limit are treated as "too late" and may
                                be rejected or driven out.
                                If you increase this value, you allow late vehicles a larger grace period and they are less
                                likely to be rejected. If you decrease this value, the system becomes stricter with
                                delays, and vehicles that arrive too long after their scheduled time will more often be rejected.
                            </p>

                            <h3>WaitingAreaBefore</h3>
                            <p>
                                WaitingAreaBefore defines how long before the scheduled time a vehicle with an
                                assigned dock door is allowed to go directly to the dock door instead of first entering the
                                waiting area. In the actual configuration, this will appear as separate values such as
                                InboundWaitingAreaBefore, OutboundWaitingAreaBefore and
                                TomgodsWaitingAreaBefore.
                                If you increase this value, vehicles with a dock door can go straight to the dock door
                                earlier before their scheduled time, which can speed up the process when capacity is
                                available. If you decrease this value, vehicles will need to be closer to their scheduled
                                time before they are allowed to skip the waiting area and drive directly to the dock door.
                            </p>

                            <h3>WaitingAreaAfter</h3>
                            <p>
                                WaitingAreaAfter defines how long after the scheduled time a vehicle with an assigned
                                dock door is allowed to go directly to the dock door instead of first entering the waiting
                                area. In the configuration, this will be represented as InboundWaitingAreaAfter,
                                OutboundWaitingAreaAfter and TomgodsWaitingAreaAfter for the three order types.
                                If you increase this value, vehicles that arrive later than their scheduled time can still go
                                straight to the dock door for a longer period, which can help keep the flow moving even
                                when there are delays. If you decrease this value, late arrivals will more quickly fall out
                                of the "go directly to dock door" window and may need to use the waiting area or be
                                rejected, depending on the other settings.
                            </p>

                            <h3>LEDMessageTimeout</h3>
                            <p>
                                Number of minutes before a vehicle is removed from the LED sign.
                            </p>

                            <h3>RetentionDays</h3>
                            <p>
                                Number of days before data is deleted in the Dopago database.
                            </p>

                            <h3>TomgodsAutoComplete</h3>
                            <p>
                                Number of minutes before a tomgods order is automatically set to completed.
                            </p>

                        </section>

                        <section className="section">
                            <h2>Dock Doors</h2>
                            <p>
                                An overview of all dock doors. You can add, edit, and delete dock doors, as well as block them.
                            </p>
                        </section>

                        <section className="section">
                            <h2>Commodities</h2>
                            <p>
                                Overview of commodities. You can add, edit, and delete commodities here.
                            </p>
                        </section>

                        <section className="section">
                            <h2>Messages</h2>
                            <p>
                                Overview of pre-defined messages. Each message defined here is used by the system. You can edit the Swedish text here.
                            </p>
                        </section>
                    </section>

                </div>
            </main>

            <footer className="footer">
                <div className="container">
                    <p>&copy; 2025 Dopago ApS. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}

export default App;
